import React from 'react';
import { Card } from '@/components/ui/card';
import { Award, BadgeCheck, Clock, Headphones, Package, Trophy } from 'lucide-react';

const Features = () => {
    const features = [
        {
            icon: Award,
            title: 'Superior Quality',
            description: 'Our products are crafted from the finest materials, ensuring durability and strength for all your construction projects.'
        },
        {
            icon: BadgeCheck,
            title: 'Competitive Prices',
            description: 'We offer the best rates in the market without sacrificing the quality of our construction materials.'
        },
        {
            icon: Trophy,
            title: 'Extensive Experience',
            description: 'With decades of expertise, we bring unmatched knowledge and reliability to the construction materials industry.'
        },
        {
            icon: Headphones,
            title: 'Customer Support',
            description: 'Our dedicated team is here to assist you with all inquiries and ensure your satisfaction.'
        },
        {
            icon: Clock,
            title: 'On-Time Delivery',
            description: 'We prioritize timely deliveries to keep your construction projects on schedule and running smoothly.'
        },
        {
            icon: Package,
            title: 'Proven Reliability',
            description: 'Trusted by countless clients, our materials consistently meet the highest standards of quality and performance.'
        }
    ];

    return (
        <section id="why-choose" className="py-20 lg:py-28 bg-card">
            <div className="section-container">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <p className="text-primary font-medium text-sm uppercase tracking-wider mb-3">
                        Why Choose Us
                    </p>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground section-title">
                        Our Advantages
                    </h2>
                </div>

                {/* Features Grid */}
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                    {features.map((feature, index) => (
                        <Card 
                            key={index}
                            className="feature-card group border-border hover:border-primary/30"
                        >
                            <div className="icon-box mb-6 group-hover:scale-110 transition-transform duration-300">
                                <feature.icon className="w-7 h-7 text-primary" />
                            </div>
                            <h3 className="font-display text-xl font-semibold text-foreground mb-3">
                                {feature.title}
                            </h3>
                            <p className="text-muted-foreground leading-relaxed">
                                {feature.description}
                            </p>
                        </Card>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Features;
